import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getPaymentHistory } from "../redux/actions/paymentHistoryAction";

function PaymentHistory() {
  const dispatch = useDispatch();
  const { loading, paymentHistory } = useSelector(
    (state) => state.paymentReducer
  );

  const [pagination, setPagination] = useState({
    page: 1,
    page_size: 10,
  });

  useEffect(() => {
    dispatch(getPaymentHistory(pagination));
  }, [pagination, dispatch]);

  const getStatusClasses = (status) => {
    if (status === "Done") return "text-green-700 bg-green-100";
    if (status === "Pending") return "text-yellow-800 bg-yellow-100";
    return "";
  };

  const handlePrev = () => {
    setPagination((prev) => ({
      ...prev,
      page: Math.max(prev.page - 1, 1),
    }));
  };

  const handleNext = () => {
    setPagination((prev) => ({
      ...prev,
      page: Math.min(prev.page + 1, paymentHistory?.total_pages || 1),
    }));
  };

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col items-center px-4 py-8">
      <h2 className="text-2xl font-semibold mb-6 w-full max-w-6xl">
        Payment History
      </h2>

      {loading && <p>Loading...</p>}

      {!loading && paymentHistory?.results?.length > 0 ? (
        <>
          {paymentHistory.results.map((item, index) => (
            <div
              key={index}
              className="w-full max-w-6xl bg-white rounded-2xl shadow-sm p-4 flex max-md:flex-col gap-2 justify-between md:items-center mb-4"
            >
              <div className="shrink max-md:flex items-center gap-3">
                <p className="text-sm text-gray-500 whitespace-nowrap">
                  Order ID
                </p>
                <p class="truncate w-full overflow-hidden text-ellipsis whitespace-nowrap">
                  {item.order_no}
                </p>
              </div>
              <div className="flex flex-col md:flex-row">
                <div className="flex-1 max-md:flex items-center gap-3">
                  <p className="text-sm text-gray-500">Paid Amount</p>
                  <p className="text-black font-small text-sm">
                    {item?.amount_paid.toFixed(2)}
                  </p>
                </div>

                <div className="flex-1 max-md:flex items-center gap-3">
                  <p className="text-sm text-gray-500">Remaining Amount</p>
                  <p className="text-black font-small text-sm">
                    {item.pending_amount?.toFixed(2)}
                  </p>
                </div>

                <div className="flex-1 max-md:flex items-center gap-3">
                  <p className="text-sm text-gray-500">Total Amount</p>
                  <p className="text-black font-small text-sm">
                    {item.total_amount?.toFixed(2)}
                  </p>
                </div>

                <div className="flex-1 max-md:flex items-center gap-3">
                  <p className="text-sm text-gray-500">Payment Mode</p>
                  <p className="text-black font-small text-sm">
                    {item?.payment_mode == "" ? "-" : item?.payment_mode}
                  </p>
                </div>
              </div>
              <div className="flex justify-end">
                <span
                  className={`text-sm px-3 py-1 rounded font-semibold text-center ${getStatusClasses(
                    "Done"
                  )}`}
                >
                  ✓ {"Done"}
                </span>
              </div>
            </div>
          ))}

          {/* Pagination Controls */}
          <div className="flex items-center gap-4 mt-4">
            <button
              onClick={handlePrev}
              disabled={pagination.page === 1}
              className="px-4 py-1 bg-gray-200 rounded hover:bg-gray-300 disabled:opacity-50"
            >
              Prev
            </button>
            <span className="text-sm text-gray-700">
              Page {pagination.page} of {paymentHistory?.total_pages}
            </span>
            <button
              onClick={handleNext}
              disabled={pagination.page === paymentHistory?.total_pages}
              className="px-4 py-1 bg-gray-200 rounded hover:bg-gray-300 disabled:opacity-50"
            >
              Next
            </button>
          </div>
        </>
      ) : (
        !loading && (
          <p className="text-gray-500">No payment history available.</p>
        )
      )}
    </div>
  );
}

export default PaymentHistory;
